import React from 'react';
import injectSheet from 'react-jss';

export const AssetTags = ({ assetTags, classes }) => {
    const tagsLabels = assetTags.map((tag) => <div key={`label-${tag}`} className={(classes.label)}>{tag}</div>);
    return (
        <div className={classes.container}>
            {tagsLabels}
        </div>
    );
};

const style = {
    container: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        flexWrap: 'wrap',
    },
    label: {
        height: 24,
        lineHeight: '24px',
        backgroundColor: 'rgba(153, 153, 153, 0.14)',
        color: 'rgba(0, 0, 0, 0.54)',
        borderRadius: 16,
        marginTop: 2,
        marginRight: 5,
        paddingLeft: 10,
        paddingRight: 10,
        width: 'auto',
    },
};

export default injectSheet(style)(AssetTags);



// WEBPACK FOOTER //
// ./src/components/assets/AssetTags.js